import React from 'react';
import {Box, styled} from '@mui/material';
import {media} from '@/styles/mediaQueries';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/styles/legacyColors';

const StyledContainer = styled(Box)(() => ({
  border: `1px solid ${LEGACY_COLORS.GRAY_LIGHTER}`,
  borderRadius: '8px',
  padding: '16px 46px 19px',
  marginBottom: '39px',
  marginTop: '28px',
  backgroundColor: '#FFFFFF',
  [media.mobile]: {
    padding: '16px 13px 16px',
    borderRadius: '0',
  },
}));

const StyledText = styled('div')(() => ({
  color: LEGACY_COLORS.GRAY_MEDIUM_DARK,
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '22px',
  fontWeight: '300',
  margin: 0,
}));

const StyledPrivacyLink = styled('a')(() => ({
  color: LEGACY_COLORS.BLUE,
  fontWeight: '400',
  textDecoration: 'none',
}));

/**
 * LegalSocialNote - A component that displays legal disclaimer text for social account connection
 * with a Privacy Policy link
 */
function LegalSocialNote() {
  return (
    <StyledContainer>
      <StyledText>
        {translate(
          'By connecting your social accounts you allow Brands to see your content style and audience! The more social accounts you link, the better brands can get to know you and select you for relevant gigs.'
        )}{' '}
        {translate('By linking a social account, you agree to our')}{' '}
        <StyledPrivacyLink
          href="https://popularpays.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {translate('Privacy Policy')}
        </StyledPrivacyLink>
      </StyledText>
    </StyledContainer>
  );
}

export default LegalSocialNote;
